export enum MenuEnum {
  SERVICES = 'Services',
  ORDERS = 'Orders',
  ACCOUNT = 'Account',
  BAG = 'Bag',
  MENU = 'Menu',
}
export enum MenuPathEnum {
  SERVICES = '/services',
  ORDERS = '/orders',
  ACCOUNT = '/account',
  BAG = '#bag',
  MENU = '#Menu',
}
